import { Component } from '@angular/core';
import { MdFooterLinks } from 'miljodir-wc/dist/src/components/footer/footer';
import { Routes } from '../app-routing.module';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  links: MdFooterLinks[] = [
    {
      link: 'https://www.miljodirektoratet.no',
      text: 'Miljodirektoratet.no'
    },
    {
      text: 'NavigationHeader',
      link: Routes.navigationHeader
    }
  ];

  explanation = `Since different applications have different layout, the developer decides the width of the container. Often the
  applikasjonen use some sort of grid layout.
  Below is an example for grid layout, and another one where you simply override the left and right padding of the md-footer
  (<b>--footer-padding-left</b> and <b>--footer-padding-right</b>)`;

  gridExplanation = `Since different applications have different layout, the developer decides the width of the container. Often the
  applikasjonen use some sort of grid layout.
  Below is an example for grid layout, and another one where you simply override the left and right padding of the md-footer
  (<b>--footer-padding-left</b> and <b>--footer-padding-right</b>)

  For the responsive example, one note is to set the wrapping background and the md-footer background
  (<b>--footer-background-color</b>) to the same value.`;

  codeExample = `.footer-background {
    background: $color-primary-10;
    --footer-background-color: $color-primary-10;
    border-top: 1px solid $color-border-variant;
    --footer-padding-right: 0;
    --footer-padding-left: 0;
  }`;

  codeBadExample = `.footer-background {
    background: $color-orange-dark;
    border-top: 1px solid $color-border-variant;
    --footer-padding-right: 0;
    --footer-padding-left: 0;
  }`;

  codeExamplePadding = `{
  --footer-padding-right: 150px;
  --footer-padding-left: 150px;
  }`;

}
